<button (click)="executableFunction()" [disabled]="condition" mat-raised-button class="me-3">
    <ng-content></ng-content>
</button>
